import { memo } from 'react';

import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

const AppTypography = memo(function AppTypography({
  children,
  variant = 'body1',
  component,
  color = 'text.primary',
  ...rest
}) {
  return (
    <Typography variant={variant} component={component} color={color} {...rest}>
      {children}
    </Typography>
  );
});

AppTypography.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  component: PropTypes.elementType,
  color: PropTypes.string,
};

export default AppTypography;
